/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WaterCirculationTime } from './waterCirculationTime';


export interface StatusCodeValueWaterCirculationTime { 
    value?: WaterCirculationTime;
    status_code?: number;
}

